import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from "react-i18next";

// styles
import './style.scss';

// layout components
import Preloader from 'components/Preloader';
import ErrorBoundary from 'engine/ErrorBoundary';

// antd component
import { Radio, Empty } from 'antd';

// utils
import { getAttendancesOnDate } from 'utils/helpers/helper.generateData';
import { sortByKey, getObjId } from 'utils/helpers/helper.general';
import { convertTimeToString } from "utils/moment/moment.utils";

function PresencesListCourses({
  dataSourse,
  selectedDate,
  checkedCourse,
  currentCourse,
  // states
  loading,
  // action
  setCheckedCourse,
  getCourse,
  // default props
  className,
}) {
  const childClassNames = classNames('presences-list-courses', className);
  const { t } = useTranslation();

  const onChangeRadio = useCallback(
    e => {
      if (e.target.checked) {
        setCheckedCourse(e.target.value);
        getCourse(e.target.value);
      }
    },
    [dataSourse],
  );

  const renderItem = useCallback((item, classAtt, checkedAtt) => {
    return (
      <Radio
        key={getObjId(item)}
        value={getObjId(item)}
        className={`presences-radio-item` + classAtt + checkedAtt}
      >
        <span className={`presences-list-item`}>
          {item?.subject?.color && (
            <span
              className="courses-list-color"
              style={{
                backgroundColor: `${
                  item?.subject?.color
                    ? item?.subject?.color
                    : 'transparent'
                }`,
              }}
            />
          )}

          <span className="list-items-meta">
            <span className="list-items-meta-header">
              {item?.course_time_start && (
                <span className="courses-list-time">
                  {convertTimeToString(item?.course_time_start)}
                </span>
              )}
              {item?.subject?.name && (
                <span className="list-item-meta-title">
                  {item?.subject?.name}
                </span>
              )}
            </span>
            <span className="list-items-description">
              {item?.course_code}
            </span>
          </span>
        </span>
      </Radio>
    );
  }, []);

  const renderList = useCallback(() => {
    return dataSourse?.length > 0 && dataSourse?.map((item, inx, arr) => {
        let courseData = {...item};
        courseData.title =
          `<span class="time">${convertTimeToString(
            item?.course_time_start,
          )}</span> <span class="cours-name">${item?.subject?.name}</span>` ||
          "";
        const currentAttendanceArr = getAttendancesOnDate(
          courseData,
          selectedDate,
        );
        const att = currentAttendanceArr?.[0];

        const classAtt =
          getObjId(att?.course) == getObjId(courseData)
            ? " hasAtt"
            : " noAtt";

        const checkedAtt =
          getObjId(checkedCourse) == getObjId(courseData)
            ? " checkedRadio"
            : "";
        return renderItem(courseData, classAtt, checkedAtt);
      })
      .sort(sortByKey("title"));
  }, [dataSourse, dataSourse?.attendances, selectedDate, checkedCourse, getAttendancesOnDate]);

  return (
    <div className={childClassNames}>
      <ErrorBoundary>
        {!loading && (dataSourse || (dataSourse && dataSourse.length > 0)) && (
          <Radio.Group
            className="presences-list-courses__list"
            name={`presences-list-courses`}
            onChange={onChangeRadio}
            defaultValue={null}
            value={getObjId(checkedCourse) || null}
          >
            {renderList()}
          </Radio.Group>
        )}
        {!loading &&
          (!dataSourse || (dataSourse && dataSourse.length == 0)) && (
            <Empty description={t("errors.noDataOnRequest")} />
          )}
        {loading && <Preloader className="tcf-spin" />}
      </ErrorBoundary>
    </div>
  );
}

PresencesListCourses.defaultProps = {
  loading: false,
};
PresencesListCourses.propTypes = {
  dataSourse: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.array.isRequired,
  ]),
  checkedCourse: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
    PropTypes.string.isRequired,
  ]),
  selectedDate: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
    PropTypes.string.isRequired,
  ]),
  loading: PropTypes.bool,
  getCourse: PropTypes.func,
};

export default PresencesListCourses;
